<label *ngIf="!labelbold" class="form-label d-block">{{label}}</label>
<label *ngIf="labelbold"  class="form-label d-block bold">{{label}}</label>
<mat-form-field appearance="outline" floatLable="never" class="w-100 mb-3 doc-custom-input">
    <input matInput [type]="type" [placeholder]="placeholder" autocomplete="off" [value]="value" [disabled]="disabled"
        (input)="changed($event.target.value)" (blur)="touched()" [matAutocomplete]="inputSuggestions" #inputEl>
    <mat-icon matSuffix *ngIf="isPassword" class="passwordStatusBtn" (click)="togglePassword()">
        <i class="fi-rr-eye-crossed" *ngIf="type==='text'"></i>
        <i class="fi-rr-eye" *ngIf="type==='password'"></i>
    </mat-icon>
    <mat-icon matSuffix *ngIf="icon"> <i [class]="icon"></i> </mat-icon>
    <mat-hint>
        <doc-form-field-error [parentForm]="parentForm" [controlName]="controlName"></doc-form-field-error>
    </mat-hint>

</mat-form-field>

<mat-autocomplete #inputSuggestions="matAutocomplete" (optionSelected)="optionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions" [value]="option.key">{{option.value}}</mat-option>
</mat-autocomplete>